"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAutoCachingMachine = void 0;
const createAutoCachingMachine = (createEntry) => {
    const cache = new Map();
    return async (key) => {
        let match = cache.get(key);
        if (!match) {
            match = await createEntry(key);
            cache.set(key, match);
        }
        return match;
    };
};
exports.createAutoCachingMachine = createAutoCachingMachine;
//# sourceMappingURL=cache.js.map